import type {
  TableCommandFactory,
  TableRowIdValue,
} from 'components/Table/model/TableModel';

type SetRowSelectedCommand = {
  rowId: TableRowIdValue;
  selected: boolean;
};

export const setRowSelected: TableCommandFactory<SetRowSelectedCommand> =
  (cmdContext) => (command) => {
    cmdContext.updateState((draft) => {
      draft.selectedRows[command.selected ? 'add' : 'delete'](command.rowId);
      if (!command.selected) {
        draft.allRowsSelectState = 'unchecked';
      }
    });
  };
